// ProductNewsHost — mount MỘT lần trong vỏ trang đã đăng nhập (Core Layout · Work AppLayout).
//
// Nó lo ba việc để mọi nơi khác chỉ cần gọi `openProductNews(id)`:
//   1. Vẽ khung đọc bài khi kho có `openId`.
//   2. Đăng ký opener 'productNews' với kernel openEntityLink ⇒ bấm thẻ bài trong chat, link
//      `/whats-new/<id>` hay `?newsId=<id>` trong tin nhắn đều bung popup TẠI CHỖ (không rời chat).
//   3. Đọc `?newsId=` trên URL (link chia sẻ, thẻ chat mở ở tab mới) để tự bung bài.
//
// Không phải Provider/Context: kho nằm ở module (productNewsStore) nên chuông, trang và thẻ chat
// gọi thẳng, khỏi lo thứ tự lồng Provider (bài học drawer lồng drawer, [[project_drawer_provider_nesting_dead_click]]).
import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ProductNewsReader from './ProductNewsReader';
import { closeProductNews, openProductNews, useProductNews } from './productNewsStore';
import { registerEntityOpener } from '../../utils/openEntity';

export default function ProductNewsHost() {
  const { openId, openPreview } = useProductNews();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => registerEntityOpener('productNews', (id) => openProductNews(id)), []);

  useEffect(() => {
    const id = new URLSearchParams(location.search).get('newsId');
    if (id) openProductNews(id);
  }, [location.search]);

  const close = useCallback(() => {
    closeProductNews();
    const sp = new URLSearchParams(location.search);
    if (sp.has('newsId')) {
      sp.delete('newsId');
      const qs = sp.toString();
      navigate({ pathname: location.pathname, search: qs ? `?${qs}` : '' }, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  const openApp = useCallback((path) => {
    closeProductNews();
    if (path) navigate(path);
  }, [navigate]);

  if (!openId) return null;
  return <ProductNewsReader key={openId} id={openId} preview={openPreview} onClose={close} onOpenApp={openApp} />;
}
